export const isMock = false;

export const mockData = {
  'sns/club/mainpage': {
    "club": {
      "club_id": 0,
      "host": "string",
      "name": "string",
      "desc": "string",
      "region": "string",
      "lang": "string",
      "icon": "string",
      "label": "string",
      "background": "string",
      "status": "OK_STATUS",
      "create_time": "string",
      "update_time": "string",
      "member": 0,
      "today_active": 0,
      "top_celebrity": "string",
      "show_id": 0,
      "regionName": "string",
      "registered_tournaments_num": 0
    },
    "creator": {
      "openid": "string",
      "nickname": "string",
      "avatar": "string",
      "uid": "string",
      "region": "string",
      "register_time": "string",
      "gender": "UNKNOWN",
      "status": 0,
      "partition": 0,
      "is_app": 0,
      "cert": {
        "certification": "string",
        "cert_type": "CERT_PLAYER",
        "link": "string"
      },
      "rank": 0,
      "is_tim": 0,
      "level": 0,
      "flag": "string",
      "is_cert": 0
    },
    "identity": "CLUB_VISIT"
  },

};
